/**
 * Layout Engine Constants
 * 
 * Central configuration for flowchart layout spacing and dimensions.
 */

// ============================================
// LAYOUT CONFIGURATION
// ============================================
export const GAP = 40;  // Base spacing value

// Measured from actual rendered nodes - most task nodes are around 280-300px wide
// and 140-160px tall depending on content (name length, tags, etc.)
export const DEFAULT_NODE_WIDTH = 290;
export const DEFAULT_NODE_HEIGHT = 150;
export const HORIZONTAL_GAP = 40;    // Gap between nodes in same layer
export const VERTICAL_GAP = 60;      // Gap between layers (vertical spacing)
export const PADDING = GAP;

/**
 * Get node dimensions, using actual measured dimensions if available
 */
export function getNodeDimensions(taskId, nodeDimensions) {
  const dims = nodeDimensions[taskId];
  return {
    width: dims?.width || DEFAULT_NODE_WIDTH,
    height: dims?.height || DEFAULT_NODE_HEIGHT,
  };
}

